'use strict';

import angular from 'angular';
import {
  uiViewAccessibilityDirective
} from './uiview-accessibility.directive.js';

export default angular.module('georgeApp.uiRouterExtensions', [])
  .directive('uiViewAccessibility', uiViewAccessibilityDirective)
  .run(['$rootScope', '$document', function($rootScope, $document) {
    // Apply the directive to the body once
    angular.element($document[0].body).attr('ui-view-accessibility', '');
  }])
  .name;
